import { useMutation, useQueryClient } from 'react-query'
import { notification } from 'antd'
import { useTranslation } from 'react-i18next'

import { DataApi, QUERY_KEYS } from '@api'

const useUploadBulkData = (onClose: () => void) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { mutate, isLoading } = useMutation(DataApi.uploadBulkData, {
    onSuccess: response => {
      queryClient.invalidateQueries(QUERY_KEYS.UPLOAD_BULK_DATA_HISTORY)
      notification.destroy('submited')
      if (response.length > 0) {
        notification.success({
          message: `
          ${response.fileName} ${t('globals.upload_success')} ${`${response.length} ${t(
            'globals.uploaded_routes',
          )}`}
            `,
        })
      } else {
        notification.success({
          message: `
          ${response.fileName} ${t('globals.upload_success')} ${t('globals.notModified_routes')}
            `,
        })
      }
      queryClient.refetchQueries(QUERY_KEYS.ROUTES)
      onClose()
    },
    onError: () => {
      notification.destroy('submited')
      notification.error({
        message: t('globals.upload_error'),
      })
      queryClient.invalidateQueries(QUERY_KEYS.UPLOAD_BULK_DATA_HISTORY)
      onClose()
    },
  })

  return { upload: mutate, isUploading: isLoading }
}

export { useUploadBulkData }
